<tg-row class="summary-page-motors-vehicle-description-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Vehicle description</p>
    </tg-col>
    <tg-col md="6" sm="12" class="summary-page-motors-vehicle-description-section__header--right">
        <a routerLink="../{{ stepIds.descriptionAndPhotos }}"
            routerLinkActive="active"
            class="h-link-no-visited">
            {{summarySectionLinkText}} boat description
        </a >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col sm="12" class="summary-page-motors-vehicle-description-section__content">
        <span class="summary-page-motors-vehicle-description-section__content-label">Listing title:</span>
        {{ title }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col sm="12" class="summary-page-motors-vehicle-description-section__content">
        <span class="summary-page-motors-vehicle-description-section__content-label">Subtitle:</span>
        {{ subTitle }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col sm="12" class="summary-page-motors-vehicle-description-section__content">
        <span class="summary-page-motors-vehicle-description-section__content-label">Boat description:</span>
        <br />
        <show-more-text-field [displayText]="description"></show-more-text-field>
    </tg-col>
</tg-row>